<mat-divider class="pb-24"></mat-divider>
<div class="table-wrapper">
  <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows>
    <ng-container matColumnDef="displayName">
      <th mat-header-cell *matHeaderCellDef> Display Name </th>
      <td mat-cell *matCellDef="let user"> {{ user.displayName }} </td>
    </ng-container>

    <ng-container matColumnDef="givenName">
      <th mat-header-cell *matHeaderCellDef> Given Name </th>
      <td mat-cell *matCellDef="let user"> {{ user.givenName }} </td>
    </ng-container>

    <ng-container matColumnDef="surname">
      <th mat-header-cell *matHeaderCellDef> Surname </th>
      <td mat-cell *matCellDef="let user"> {{ user.surname }} </td>
    </ng-container>

    <ng-container matColumnDef="jobTitle">
      <th mat-header-cell *matHeaderCellDef> Job Title </th>
      <td mat-cell *matCellDef="let user"> {{ user.jobTitle || 'N/A' }} </td>
    </ng-container>

    <ng-container matColumnDef="mail">
      <th mat-header-cell *matHeaderCellDef> Mail </th>
      <td mat-cell *matCellDef="let user"> {{ user.mail || 'N/A' }} </td>
    </ng-container>

    <ng-container matColumnDef="mobilePhone">
      <th mat-header-cell *matHeaderCellDef> Mobile Phone </th>
      <td mat-cell *matCellDef="let user"> {{ user.mobilePhone || 'N/A' }} </td>
    </ng-container>

    <ng-container matColumnDef="userPrincipalName">
      <th mat-header-cell *matHeaderCellDef> UPN </th>
      <td mat-cell *matCellDef="let user"> {{ user.userPrincipalName }} </td>
    </ng-container>

    <ng-container matColumnDef="accountEnabled">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let user">
        {{ user.accountEnabled ? 'Active' : 'Disabled' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let user">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu class="dashboard-menu mat-menu-box" #menu="matMenu">
          @if (user.accountEnabled) {
            <button mat-menu-item (click)="disableUser(user)">
              <span class="menu-text">
                <img src="/assets/icons/Remove.svg" alt="File-icon" />&nbsp; Disable
              </span>
            </button>
          }
          @if (!user.accountEnabled) {
            <button mat-menu-item (click)="enableUser(user)">
              <span class="menu-text">
                <img src="/assets/icons/Restore.svg" alt="File-icon" />&nbsp; Activate
              </span>
            </button>
          }
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
